export default "__VITE_ASSET__DXQ4w9QR__"